// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import DocumentMeta from 'react-document-meta'
import { Link } from 'react-router-dom'
import FilePlayer from 'react-player/lib/players/FilePlayer'

// Internal Dependencies:

class HomePageHeaderVideo extends React.Component {
	constructor( props ) {
		super( props )

		this.canvas = React.createRef()

		this.state = {
			hidingVideo: false,
			showVideo: true
		}
	}

	handleVideoEnd = () => {
		this.setState( {
			hidingVideo: true
		} )

		setTimeout( () => {
			this.setState( {
				hidingVideo: false,
				showVideo: false
			} )
		}, 1 * 1000 )
	}

	render() {
		const { hidingVideo, showVideo } = this.state
		const videoClass = hidingVideo ? '-video is-hiding' : '-video'

		return (
			<div className="home-header">
				{ showVideo &&
					<div className={ videoClass }>
						<FilePlayer
							ref={ ( e ) => { this.playerRef = e } }
							playing={ true }
							url={ `${siteData.videos_url}Dan_Ch02_Sc01-04_PencilTest-no-audio.mp4` }
							controls={ false }
							volume={ 0 }
							muted={ true }
							playsinline={ true }
							style={ {} }
							onEnded={ this.handleVideoEnd }
						/>
					</div>
				||
					<div className="-image">
						<img src={ `${siteData.images_url}home-header/Dan_Ch02_Sc01_Sh05_BG_HD.jpg` } alt="" />
					</div>
				}

				<div className="-text-wrap">
					<div className="-text">
						<div className="-text-inner">
							<h1>This is the Animation Coop</h1>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {

	}
}

export default connect( mapStateToProps )( HomePageHeaderVideo )



// WEBPACK FOOTER //
// ./views/pages/home/HomePageHeaderVideo.jsx